import {BeatLoader} from "react-spinners";

const Loading = ({ loading }) => (
  <BeatLoader color="#B20000" className="text-center m-10" loading={loading}  />
);

export default Loading;
